var _path, _path2, _ellipse, _ellipse2, _path3, _path4, _path5, _ellipse3, _mask, _g, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPetriDishLb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 29,
    viewBox: "0 -20 101 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.359434 8.92702C0.359435 4.1975 22.8676 0.363458 50.6328 0.36346C78.3981 0.363463 100.906 4.1975 100.906 8.92703C100.906 11.7461 100.906 12.5625 100.906 12.5625C99.1166 5.6956 61.8484 4.16051 50.6328 4.16051C39.4173 4.16051 1.82377 5.21075 0.359434 12.5625C0.359434 12.5625 0.359434 11.7461 0.359434 8.92702Z",
    fill: "#668BA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1.00004 9.43155C1.00004 4.77479 23.1619 0.999735 50.5 0.999738C77.8381 0.99974 100 4.7748 100 9.43156C100 12.2073 100 20.6475 100 20.6475C98.2379 13.8862 61.543 12.3747 50.5 12.3747C39.457 12.3747 2.44185 13.4088 1.00004 20.6475C1.00004 20.6475 1.00004 12.2072 1.00004 9.43155Z",
    fill: "#668BA6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.4999,
    cy: 20.5685,
    rx: 49.4999,
    ry: 8.43182,
    fill: "#CCD8E1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.4999,
    cy: 20.5685,
    rx: 49.4999,
    ry: 8.43182,
    fill: "#FCE19D",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M99.9999 20.5684C99.9999 25.2252 77.838 29.0003 50.5 29.0003C23.1619 29.0003 1.00005 25.2252 1.00005 20.5684C1.00005 17.7927 1 9.35254 1 9.35254C2.76213 16.1138 39.457 17.9434 50.5 17.9434C61.543 17.9434 98.5581 16.5912 99.9999 9.35254C99.9999 9.35254 99.9999 17.7927 99.9999 20.5684Z",
    fill: "#99B2C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5918 18.5C27.5918 18.5 38.9656 19.4545 50.3393 19.4545C61.7131 19.4545 73.0869 18.5 73.0869 18.5V26.7727C73.0869 26.7727 59.15 27.7273 50.3393 27.7273C41.5287 27.7273 27.5918 26.7727 27.5918 26.7727V18.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M100.906 12.4812C100.906 17.2107 78.398 21.0447 50.6328 21.0447C22.8676 21.0447 0.359425 17.2107 0.359425 12.4812C0.359425 9.6621 0.359375 8.8457 0.359375 8.8457C2.14904 15.7126 39.4172 17.5708 50.6328 17.5708C61.8484 17.5708 99.4419 16.1974 100.906 8.8457C100.906 8.8457 100.906 9.6621 100.906 12.4812Z",
    fill: "#99B2C4"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 50.6327,
    cy: 8.92684,
    rx: 50.2734,
    ry: 8.56356,
    fill: "#99B2C4"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 18
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 50.6328,
    cy: 9.2452,
    rx: 50.2734,
    ry: 8.56356,
    fill: "#99B2C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.1882 21.6862L84.3106 1.16593L75.5249 -0.93457L4.26367 19.9088L14.1882 21.6862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M68.5293 -0.449219L11.4227 15.87L8.49414 14.9006L62.5095 -0.449219H68.5293Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4561 25.2578H49.9762V24.5076H48.3211V21.3633H47.4561V25.2578Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4409 25.2578H52.1364C53.0534 25.2578 53.4686 24.9199 53.4686 24.1639C53.4686 23.6542 53.2783 23.3506 52.8054 23.2189V23.2075C53.186 23.0757 53.3417 22.8066 53.3417 22.377C53.3417 21.6783 52.938 21.3633 52.0153 21.3633H50.4409V25.2578ZM51.306 22.9154V22.0906H51.9288C52.3498 22.0906 52.4882 22.188 52.4882 22.4973C52.4882 22.8123 52.3383 22.9154 51.8827 22.9154H51.306ZM51.306 24.5305V23.6427H51.9173C52.4305 23.6427 52.6035 23.7573 52.6035 24.0952C52.6035 24.4216 52.4478 24.5305 51.9865 24.5305H51.306Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetriDishLb);
export default __webpack_public_path__ + "static/media/petri-dish-lb.9a89ea985184dd1d4716c859b8591f67.svg";
export { ForwardRef as ReactComponent };